import React from 'react';
import PropTypes from 'prop-types';
import { FaCaretRight as CaretRightIcon, FaCaretDown as CaretDownIcon } from 'react-icons/fa';

const ToggleCaret = ({ isOpen }) => isOpen
  ? <CaretDownIcon className="icon-toggle" size={16} />
  : <CaretRightIcon className="icon-toggle" size={16} />;

ToggleCaret.propTypes = {
  isOpen: PropTypes.bool,
};

ToggleCaret.defaulProps = {
  isOpen: false,
};

export default ToggleCaret;
